export let WebChatActionType;
(function (WebChatActionType) {
  WebChatActionType["DIRECT_LINE_CONNECT_FULFILLED"] = "DIRECT_LINE/CONNECT_FULFILLED";
  WebChatActionType["DIRECT_LINE_CONNECT"] = "DIRECT_LINE/CONNECT";
  WebChatActionType["DIRECT_LINE_CONNECT_PENDING"] = "DIRECT_LINE/CONNECT_PENDING";
  WebChatActionType["DIRECT_LINE_UPDATE_CONNECTION_STATUS"] = "DIRECT_LINE/UPDATE_CONNECTION_STATUS";
  WebChatActionType["DIRECT_LINE_CONNECT_FULFILLING"] = "DIRECT_LINE/CONNECT_FULFILLING";
  WebChatActionType["DIRECT_LINE_POST_ACTIVITY"] = "DIRECT_LINE/POST_ACTIVITY";
  WebChatActionType["DIRECT_LINE_POST_ACTIVITY_PENDING"] = "DIRECT_LINE/POST_ACTIVITY_PENDING";
  WebChatActionType["DIRECT_LINE_POST_ACTIVITY_FULFILLED"] = "DIRECT_LINE/POST_ACTIVITY_FULFILLED";
  WebChatActionType["DIRECT_LINE_INCOMING_ACTIVITY"] = "DIRECT_LINE/INCOMING_ACTIVITY";
  WebChatActionType["WEB_CHAT_SET_LANGUAGE"] = "WEB_CHAT/SET_LANGUAGE";
  WebChatActionType["WEB_CHAT_SEND_MESSAGE"] = "WEB_CHAT/SEND_MESSAGE";
  WebChatActionType["WEB_CHAT_SET_SEND_TIMEOUT"] = "WEB_CHAT/SET_SEND_TIMEOUT";
  WebChatActionType["WEB_CHAT_SET_SEND_TYPING_INDICATOR"] = "WEB_CHAT/SET_SEND_TYPING_INDICATOR";
  WebChatActionType["WEB_CHAT_SET_SUGGESTED_ACTIONS"] = "WEB_CHAT/SET_SUGGESTED_ACTIONS";
  WebChatActionType["WEB_CHAT_STOP_DICTATE"] = "WEB_CHAT/STOP_DICTATE";
  WebChatActionType["WEB_CHAT_STOP_SPEAKING"] = "WEB_CHAT/STOP_SPEAKING";
  WebChatActionType["WEB_CHAT_SEND_EVENT"] = "WEB_CHAT/SEND_EVENT";
  WebChatActionType["WEB_CHAT_SET_NOTIFICATION"] = "WEB_CHAT/SET_NOTIFICATION";
  WebChatActionType["WEB_CHAT_DISMISS_NOTIFICATION"] = "WEB_CHAT/DISMISS_NOTIFICATION";
  WebChatActionType["WEB_CHAT_SET_SEND_BOX"] = "WEB_CHAT/SET_SEND_BOX";
  WebChatActionType["WEB_CHAT_SEND_FILES"] = "WEB_CHAT/SEND_FILES";
  WebChatActionType["WEB_CHAT_SET_SEND_BOX_ATTACHMENTS"] = "WEB_CHAT/SET_SEND_BOX_ATTACHMENTS";
})(WebChatActionType || (WebChatActionType = {}));